<!-- 上传 -->
<template>
  <div id="zlr-upload">
    <Upload ref="upload"
            type="drag"
            :action="baseUrl + '/file/system/upload'"
            :before-upload="handleUpload"
            :data="uploadParams"
            :on-success="onUploadSuccess"
            :style="previewImg && url ? {width: '120px', height: '120px'} : {}"
            :class="{error:!!errorMsg}">
      <div :style="previewImg && url ? {width: '120px', height: '120px'} : {padding: '20px 0'}">
          <img style="width: 120px; height: 120px" v-if="url && previewImg" :src="url" alt="123">
          <div v-else>
              <Icon type="ios-cloud-upload"
                    size="52"
                    style="color: #3399ff"></Icon>
              <p>Click or drag files here to upload</p>
          </div>
      </div>
    </Upload>
      <div v-if="type === 'OSS'">
          <div v-if="imgName || errorMsg"
               class="up-content">
              <p class="up-error"
                 v-show="!!errorMsg">{{errorMsg}}</p>
              <p class="up-name"
                 v-show="!!imgName">{{ imgName }}</p>
              <div class="up-progress-slot"
                   v-show="progress>0&&progress<1">
                  <div class="up-close"
                       @click="stopUplod">
                      <Icon type="ios-close-circle"
                            size="16" />
                  </div>
                  <div class="up-progress"
                       :style="{width: progress*100+'%'}"></div>
              </div>
          </div>
          <slot v-else></slot>
      </div>
      <div v-else>
          <div v-if="errorMsg"
               class="up-content">
              <p class="up-error"
                 v-show="!!errorMsg">{{errorMsg}}</p>
          </div>
      </div>
  </div>
</template>
<script>
import { ossSecret, ossOpen } from '@/api/oss'
import baseUrl from '_conf/url'
import profile from '_conf/env'
import { randomString } from '@/libs/tools'

export default {
  name: 'zlr-upload',
  // path: 是上传文件的路径
  // randomLength 文件名是否是随机数 如果大于0 就是根据定义的长度取随机名的长度
  // format 是否需要校验格式
  props: {
    value: {
      type: [String, Object, Array]
    },
    type: {
      type: String,
      default: 'FS'
    },
    path: {
      type: [String],
      required: true
    },
    rootPath: {
      type: String,
      default: `/docs/${profile}/mentor`
    },
    randomFilenameLength: {
      type: [Number],
      default: 0
    },
    format: {
      type: [Array],
      default () {
        return []
      }
    },
    secret: {
      type: Boolean,
      default: true
    },
    ossSupply: {
      type: String,
      default: ''
    },
    previewImg: {
      type: Boolean,
      default: false
    },
    // MB
    size: {
      type: Number,
      default: 32
    }
  },
  components: {},
  data () {
    return {
      baseUrl: baseUrl,
      errorMsg: '',
      imgName: '',
      progress: 0,
      client: '',
      uploadParams: {},
      url: undefined,
      file: undefined
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    setInit () {
      this.errorMsg = ''
      this.imgName = ''
      this.$emit('input', '')
    },
    handleUpload (file) {
      this.file = file
      this.setInit()
      let type = file.name.substring(file.name.lastIndexOf('.') + 1)
      let format = this.format
      // 判断格式
      if (format.length > 0 && !format.includes(type)) {
        let msg = 'Please note: Only ' + format.join(',') + ' files can be uploaded.'
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return false
      }
      // 判断大小
      if (this.size && file.size > this.size * 1024 * 1024) {
        let msg = `Please note: Only below ${this.size}MB files can be uploaded.`
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return false
      }
      // 判断文件名字是否含有+
      if (file.name.indexOf('+') !== -1) {
        let msg = 'Please note: Uploaded file name cannot contain special symbols.'
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return false
      }
      if (this.type === 'FS') {
        return this.buildUploadParams(file)
      } else {
        return this.ossUpload(file)
      }
    },
    uploadType (data) {
      return new Promise(resolve => {
        if (this.secret) {
          ossSecret(data, this.ossSupply).then(res => {
            resolve(res)
          })
        } else {
          ossOpen(data).then(res => {
            resolve(res)
          })
        }
      })
    },
    getUpImg (a, f) {
      let name = f.name
      this.client = new OSS.Wrapper({
        region: 'oss-cn-beijing',
        accessKeyId: a.accessid,
        secure: true,
        endpoint: a.endpoint,
        accessKeySecret: a.accessKey,
        bucket: a.bucket,
        timeout: 6000000
      })
      let the = this
      this.client.multipartUpload(a.dir + '/' + name, f, {
        progress: async function (p, checkpoint) {
          console.log(p)
          the.progress = p
        }
      }).then(res => {
        this.$emit('on-success', f)
        if (this.secret) {
          the.$emit('input', res.name)
        } else {
          the.$emit('input', `https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/${res.name}`)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 停止上传
    stopUplod () {
      this.client.cancel()
      this.imgName = ''
    },
    buildUploadParams (file) {
      this.$refs['upload'].clearFiles()
      if (this.randomFilenameLength) {
        this.uploadParams.filename = randomString(this.randomFilenameLength)
      } else {
        this.uploadParams.filename = file.name
      }
      this.uploadParams.targetDirPath = this.rootPath.replace(/\/$/g, '') + '/' + this.path
      this.uploadParams.bucket = this.secret ? 'ZLR_SP_PRIVATE' : 'ZLR_VALEON_OM'
      this.imgName = file.name
      return true
    },
    ossUpload (file) {
      let data = {
        dir: this.path
      }
      this.imgName = file.name
      this.uploadType(data).then(res => {
        this.getUpImg(res.data, file)
      })
      return false
    },
    onUploadSuccess (res) {
      this.$emit('on-success', this.file)
      if (this.secret) {
        this.$emit('input', res.data.model.objectKey)
      } else {
        this.$emit('input', res.data.model.url)
        this.url = res.data.model.url
      }
    }
  }
}
</script>
<style lang='less' scoped>
.up-error {
  color: red;
  line-height: 24px;
}
.up-name {
  margin-bottom: 12px;
}
.up-progress-slot {
  width: 100%;
  height: 4px;
  position: relative;
  background: #f0f0f0;
}
.up-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: @c-primary;
}
.up-content {
  position: relative;
}
.up-close {
  position: absolute;
  right: 0;
  top: -26px;
  cursor: pointer;
}
</style>
<style lang='less'>
#zlr-upload {
  .error {
    .ivu-upload-drag {
      border: 1px solid red;
    }
  }
}
</style>
